import { render, staticRenderFns } from "./CrewInfo.vue?vue&type=template&id=f16bb9ea&scoped=true&"
import script from "./CrewInfo.vue?vue&type=script&lang=js&"
export * from "./CrewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16bb9ea",
  null
  
)

export default component.exports